import styled, { css } from "styled-components";
import DiscardCameraButtonIcon from "components/Icons/DiscardCameraButtonIcon";
import ClosePicturePreviewIcon from "components/Icons/ClosePicturePreviewIcon";
import OkPicturePreviewIcon from "components/Icons/OkPicturePreviewIcon";

export const PicturePreviewContainer = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 666;
  top: 0;
  left: 0;
  background-color: black;
`;

export const Picture = styled.img`
  margin-left: 50%;
  transform: translateX(-50%);
  height: 100vh;
`;

export const ButtonsContainer = styled.div`
  display: grid;
  column-gap: 200px;
  grid-template-columns: auto auto;
  height: 92.16px;
  width: 100vw;
  position: fixed;
  z-index: 3;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
`;

const leftButton = css`
  margin: auto 0 auto auto;
`;

export const DiscardIcon = styled(ClosePicturePreviewIcon)`
  ${leftButton}
`;

export const CameraDiscardIcon = styled(DiscardCameraButtonIcon)`
  ${leftButton}
`;

export const OkIcon = styled(OkPicturePreviewIcon)`
  margin: auto 0;
`;
